import { isArray } from "lodash";
import * as React from "react";

import { ControlledFilter } from "components/filter";
import { FilterButton } from "components/filter/FilterButton";
import { Filter } from "constants/filters";

import { SelectedFilterLabel } from "./SelectedFilterLabel";
import { IFilterBaseProps } from "./interfaces";

export function withFilterBase<P, F extends Filter>(
  WrappedComponent: React.ComponentType<P>
): React.ComponentType<IFilterBaseProps<F>> {
  // FIXME: Fix this the next time the file is edited.
  // @ts-expect-error TS(2322): Type 'typeof (Anonymous class)' is not assignable ... Remove this comment to see the full error message
  // eslint-disable-next-line react/display-name
  return class extends React.Component<P & IFilterBaseProps<F>, Record<string, unknown>> {
    handleRemove = (): void => {
      this.props.onRemove(this.props.filterName);
    };

    handleOpen = (): void => {
      this.props.onOpen(this.props.filterName);
    };

    handleFilterRemoveClick = (event: React.MouseEvent<HTMLSpanElement>): void => {
      event.preventDefault();
      event.stopPropagation();
      this.handleRemove();
    };

    render(): JSX.Element {
      const { title, icon, removable = true } = this.props.filterConfig;

      const { filterValues, filterLabelValues, isOpen, onClose } = this.props;

      const valueIsEmpty = isArray(filterValues) ? filterValues?.length === 0 : filterValues === null;
      const invalid = Array.isArray(filterLabelValues) && filterLabelValues.find(l => l.invalid) !== undefined;

      return (
        <ControlledFilter
          title={title}
          icon={icon}
          isOpen={isOpen}
          isValid
          actionButtonText={valueIsEmpty ? "Close" : "Done"}
          onActionButtonClick={onClose}
          onClose={onClose}
          onOpen={this.handleOpen}
          onFilterRemoveClick={this.handleRemove}
          renderContent={() => isOpen && <WrappedComponent {...this.props} />}
        >
          <FilterButton
            title={title}
            icon={icon}
            removable={removable}
            selectedValuesLabel={<SelectedFilterLabel value={this.props.filterLabelValues} />}
            invalid={invalid}
            onRemove={this.handleFilterRemoveClick}
            shouldHideTitle={!valueIsEmpty}
          />
        </ControlledFilter>
      );
    }
  };
}
